import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMoon",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(a, t, i, _, f, e) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--moon"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Moon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.955 2.139a4 4 0 1 0 4.902 4.92 3.682 3.682 0 0 1-5.281-3.31 3.646 3.646 0 0 1 .38-1.61Zm1.392-.279A.5.5 0 0 0 6 1a5 5 0 1 0 5 5 .5.5 0 0 0-.852-.355 2.682 2.682 0 0 1-4.572-1.898 2.709 2.709 0 0 1 .391-1.38 2.97 2.97 0 0 1 .377-.504l.003-.003Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const g = /* @__PURE__ */ s(c, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=moon.js.map
